
import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogBody } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import TaskForm from '../tasks/TaskForm';

interface AddTaskDialogProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  newTaskTitle: string;
  setNewTaskTitle: (title: string) => void;
  newTaskDescription: string;
  setNewTaskDescription: (description: string) => void;
  newTaskDueDate: string;
  setNewTaskDueDate: (date: string) => void;
  newTaskPriority: string;
  setNewTaskPriority: (priority: string) => void;
  newTaskAssignedTo: string;
  setNewTaskAssignedTo: (assignedTo: string) => void;
  handleAddTask: () => void;
  priorityOptions: { value: string; label: string }[];
  newTaskCategories?: string[];
  setNewTaskCategories?: (categories: string[]) => void;
  newTaskReminderTimes?: string[];
  setNewTaskReminderTimes?: (reminderTimes: string[]) => void;
}

const AddTaskDialog: React.FC<AddTaskDialogProps> = ({
  isOpen,
  setIsOpen,
  newTaskTitle,
  setNewTaskTitle,
  newTaskDescription,
  setNewTaskDescription,
  newTaskDueDate,
  setNewTaskDueDate,
  newTaskPriority,
  setNewTaskPriority,
  newTaskAssignedTo,
  setNewTaskAssignedTo,
  handleAddTask,
  priorityOptions,
  newTaskCategories = [],
  setNewTaskCategories = () => {},
  newTaskReminderTimes = [],
  setNewTaskReminderTimes = () => {},
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold">Add New Task</DialogTitle>
        </DialogHeader>
        
        <DialogBody>
          <TaskForm
            newTaskTitle={newTaskTitle}
            setNewTaskTitle={setNewTaskTitle}
            newTaskDescription={newTaskDescription}
            setNewTaskDescription={setNewTaskDescription}
            newTaskDueDate={newTaskDueDate}
            setNewTaskDueDate={setNewTaskDueDate}
            newTaskPriority={newTaskPriority}
            setNewTaskPriority={setNewTaskPriority}
            newTaskAssignedTo={newTaskAssignedTo}
            setNewTaskAssignedTo={setNewTaskAssignedTo}
            priorityOptions={priorityOptions}
            newTaskCategories={newTaskCategories}
            setNewTaskCategories={setNewTaskCategories}
            newTaskReminderTimes={newTaskReminderTimes}
            setNewTaskReminderTimes={setNewTaskReminderTimes}
          />
        </DialogBody>
        
        <DialogFooter>
          <Button 
            variant="outline" 
            onClick={() => setIsOpen(false)}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleAddTask}
          >
            Add Task
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddTaskDialog;
